/**
 * Extrai as iniciais de um nome
 * @param name - Nome completo ou null/undefined
 * @returns String com as iniciais (ex: "João Silva" → "JS", "Maria" → "MA")
 */
export const getInitials = (name?: string | null): string => {
  const parts = (name ?? "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return "PR";
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return `${parts[0]!.slice(0, 1)}${parts[parts.length - 1]!.slice(0, 1)}`.toUpperCase();
};

/**
 * Extrai as iniciais das duas primeiras palavras de um nome
 * @param name - Nome completo
 * @returns String com até 2 iniciais (ex: "João Silva Souza" → "JS")
 */
export const initials = (name: string): string =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("");
